import {
  ParagraphBlock,
  ParagraphBlockCta,
  ParagraphChapter,
  ParagraphChapterSection,
  ParagraphCta,
  ParagraphCtaGroup,
  ParagraphCtaGroupItem,
  ParagraphCtaTeaser,
  ParagraphDossiersSelected,
  ParagraphDownloads,
  ParagraphFAQ,
  ParagraphFaqItem,
  ParagraphFAQSelection,
  ParagraphIframe,
  ParagraphImage,
  ParagraphImageAndText,
  ParagraphLatestContent,
  ParagraphLatestNews,
  ParagraphLivechart,
  ParagraphPodcast,
  ParagraphQuote,
  ParagraphTeaser,
  ParagraphText,
  ParagraphThreeTeasers,
  ParagraphUSPs,
  ParagraphVideo,
  ParagraphWebform,
} from '../implementations';


const mappers = {
  block_cta: ParagraphBlockCta,
  block_reference: ParagraphBlock,
  chapter: ParagraphChapter,
  cta_group_items: ParagraphCtaGroupItem,
  cta_group: ParagraphCtaGroup,
  cta_teaser: ParagraphCtaTeaser,
  cta: ParagraphCta,
  dossiers_selected: ParagraphDossiersSelected,
  downloads: ParagraphDownloads,
  faq_item: ParagraphFaqItem,
  faq_selection: ParagraphFAQSelection,
  faq: ParagraphFAQ,
  iframe: ParagraphIframe,
  image_and_text: ParagraphImageAndText,
  image: ParagraphImage,
  latest_content: ParagraphLatestContent,
  latest_news: ParagraphLatestNews,
  livechart: ParagraphLivechart,
  podcast: ParagraphPodcast,
  quote: ParagraphQuote,
  section: ParagraphChapterSection,
  teaser: ParagraphTeaser,
  text: ParagraphText,
  three_teasers: ParagraphThreeTeasers,
  usps: ParagraphUSPs,
  video: ParagraphVideo,
  webform: ParagraphWebform,
};

export default mappers;
